import { getSortAndFilterOption, SortAndFilterDisplayField } from 'stores/adapters/bex-api/search/search-sort-filter-adapter';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { isPriceSliderFilter } from 'utils/price-filter-utils';

import { PriceRangeInput } from '__generated__/api';

export const getPriceRangeInput = (searchCriteria: SearchCriteriaModel, sortAndFilterOptions: any): PriceRangeInput | null => {
  if (searchCriteria.price && searchCriteria.price.length) {
    const priceOption = getSortAndFilterOption(SortAndFilterDisplayField.PRICE, sortAndFilterOptions);
    const { min = null, max = null } = priceOption || {};

    if (isPriceSliderFilter(min, max)) {
      const [minInput, maxInput] = searchCriteria.price.map(x => Number.parseInt(x));

      if ((minInput || minInput === 0) && (maxInput || maxInput === 0)) {
        return {
          min: minInput,
          max: maxInput
        };
      }
    }
  }

  return null;
};
